import { css } from '@emotion/react';
import type { ComponentProps, FC } from 'react';
import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import { Chip, colors, RiCircleFill } from '@itandi/itandi-bb-ui';

const INPUT_HEIGHT = 36;

type ScrollProps = DeepReadonly<{
  /** CurrentFilter の高さ */
  height?: number;
  /** CurrentFilter がスクロール可能かどうか<br />`false`の場合は中身の高さいっぱいまで広がり、`true`の場合は height の高さとなってスクロール可能となる */
  scroll: true;
}>;

type NoScrollProps = DeepReadonly<{
  height?: never;
  scroll?: false;
}>;

type ChipProps = ComponentProps<typeof Chip>;
type Option = {
  /** Chip の icon の色 */
  iconColor?: ChipProps['iconColor'];
  /** Chip の label */
  label: ChipProps['label'];
  /** Chip の閉じるボタンをクリックしたときのコールバック */
  onRemove?: ChipProps['onRemove'];
};

type CommonProps = DeepReadonly<{
  /** 表示する option の配列 */
  options: Option[];
}>;

type Props = CommonProps & (ScrollProps | NoScrollProps);

/**
  @deprecated 削除したい場合は相談ワークフローからデザインの修正を依頼してください（新しい画面では使わないでください）
 */
export const CurrentFilter: FC<Props> = ({
  height = INPUT_HEIGHT,
  options,
  scroll = true
}) => (
  <div
    css={css(
      {
        alignContent: 'flex-start',
        alignItems: 'flex-start',
        background: colors['gray-100'],
        border: `1px solid ${colors['gray-100']}`,
        borderRadius: 4,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 4,
        minHeight: INPUT_HEIGHT,
        padding: 8,
        width: '100%'
      },
      scroll
        ? {
            height,
            overflowY: 'scroll'
          }
        : undefined
    )}
  >
    {options.map((option) => (
      <Chip
        key={option.label}
        Icon={
          typeof option.iconColor === 'string' && !!option.iconColor
            ? RiCircleFill
            : undefined
        }
        iconColor={option.iconColor}
        label={option.label}
        onRemove={option.onRemove}
      />
    ))}
  </div>
);
